import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';

const DigitalGraph = ({ title, value, color, textColor, strokeWidth = 0, size = 80, ...rest }) => {
	const theme = useTheme();
	
	return (
		<Box
			columnGap={2}
			sx={{
				display: 'grid',
				gridTemplateColumns: '1fr',
				gridTemplateRows: 'auto 1fr',
				gridColumnGap: '0px',
				gridRowGap: '10px',
				marginBottom: 1
			}}
		>
			<Typography textAlign={'center'}>{title}</Typography>
			<Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
				<svg
					width={size}
					height={size}
					style={{
						transition: 'all 0.25s 0.25s'
					}}
					viewBox={`0 0 ${size} ${size}`}
				>
					<g>
						<circle
							style={{
								fill: color || theme.palette.success.light,
								strokeWidth: strokeWidth
							}}
							cx={'50%'}
							cy={'50%'}
							r={size / 2}
						></circle>
						<text
							x="50%"
							y="50%"
							textAnchor="middle"
							dy=".3em"
							fontWeight={'normal'}
							stroke={textColor || theme.palette.text.primary}
							fill={textColor || theme.palette.text.primary}
							fontSize={14}
						>
							{value}
						</text>
					</g>
				</svg>
			</Box>
		</Box>
	);
};
export default DigitalGraph;